import { createActionGroup, props } from '@ngrx/store';
import { CreateTextTemplateDto, TextTemplateDto, UpdateTextTemplateDto } from '@travel-planner/library-travel-planner-api';
import { NavigationDescription } from '../../../../core/models/navigation-description';
import { ApiError } from '../../../../core/models/api-error';
import { ImageUploadItem, ImageUrlUploadItem } from '../../../../core/models/image-upload';

export const TextTemplatesActions = createActionGroup({
    source: 'TextTemplates',
    events: {
        'Load Text Templates': props<{ searchTerm: string; lastTextTemplateId?: number | undefined; includeTotal: boolean }>(),
        'Load Text Templates Success': props<{ textTemplates: TextTemplateDto[]; total?: number | undefined }>(),
        'Load Text Templates Failure': props<{ error: ApiError }>(),
        'Scroll Text Templates List': props<{ scrollPosition: number }>(),
        // Detail
        'Load Text Template': props<{ id: string }>(),
        'Load Text Template Success': props<{ textTemplate: TextTemplateDto }>(),
        'Load Text Template Failure': props<{ id: string; error: ApiError }>(),
        'Add Text Template': props<{ textTemplateToAdd: CreateTextTemplateDto }>(),
        'Add Text Template Success': props<{ textTemplate: TextTemplateDto; navigateOnSuccess?: NavigationDescription }>(),
        'Add Text Template Failure': props<{ error: ApiError }>(),
        'Update Text Template': props<{ id: number; textTemplateToUpdate: UpdateTextTemplateDto; navigateOnSuccess?: NavigationDescription }>(),
        'Update Text Template Success': props<{ updatedTextTemplate: TextTemplateDto; navigateOnSuccess?: NavigationDescription }>(),
        'Update Text Template Failure': props<{ id: number; error: ApiError }>(),
        'Delete Text Template': props<{ id: number }>(),
        'Delete Text Template Success': props<{ id: string; navigateOnSuccess?: NavigationDescription }>(),
        'Delete Text Template Failure': props<{ id: number; error: ApiError }>(),

        // Images
        'Upload Text Template Images': props<{ id: number; files: ImageUploadItem[] }>(),
        'Upload Text Template Image Urls': props<{ id: number; urls: ImageUrlUploadItem[] }>(),
        'Upload Text Template Images Success': props<{ updatedTextTemplate: TextTemplateDto }>(),
        'Upload Text Template Images Failure': props<{ id: number; error: ApiError }>(),
        'Delete Text Template Image': props<{ textTemplateId: number; imageId: number }>(),
        'Delete Text Template Image Success': props<{ textTemplateId: number; imageId: number }>(),
        'Delete Text Template Image Failure': props<{ textTemplateId: number; imageId: number; error: ApiError }>(),
        'Reorder Text Template Images': props<{ textTemplateId: number; imageId: number; newIndex: number }>(),
        'Reorder Text Template Images Success': props<{ updatedTextTemplate: TextTemplateDto }>(),
        'Reorder Text Template Images Failure': props<{ textTemplateId: number; error: ApiError }>(),
    }
});
